import React from 'react';
import { Table } from 'antd';
import { stringToMoneyFormat } from 'utils';

const SummaryTable = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { data = [], type = 'PRODUCT' } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /**
   * 테이블 컬럼 설정
   * --
   */
  const columns = React.useMemo(() => {
    const text = {
      PRODUCT: '상품',
      MENU: '메뉴',
    };

    return [
      {
        key: `${type.toLocaleLowerCase()}_name`,
        dataIndex: `${type.toLocaleLowerCase()}_name`,
        title: `${text[type]}명`,
        fixed: 'left',
      },
      {
        key: 'total_sales',
        dataIndex: 'total_sales',
        title: '총매출',
        render: (item) => stringToMoneyFormat(item),
      },
      {
        key: 'COMPLETED_sales',
        dataIndex: 'COMPLETED_sales',
        title: '순매출',
        render: (item) => stringToMoneyFormat(item),
      },
      {
        key: 'CANCELLED_sales',
        dataIndex: 'CANCELLED_sales',
        title: '환불금액',
        render: (item) => stringToMoneyFormat(item),
      },
      {
        key: 'COMPLETED_count',
        dataIndex: 'COMPLETED_count',
        title: '거래건수',
        render: (item) => stringToMoneyFormat(item),
      },
      {
        key: 'CANCELLED_count',
        dataIndex: 'CANCELLED_count',
        title: '환불건수',
        render: (item) => stringToMoneyFormat(item),
      },
      ...(type === 'PRODUCT'
        ? [
            {
              key: 'DELIVERY',
              dataIndex: 'DELIVERY',
              title: '배송 주문건',
              render: (item) => stringToMoneyFormat(item),
            },
            {
              key: 'STORE_PICKUP',
              dataIndex: 'STORE_PICKUP',
              title: '픽업 주문건',
              render: (item) => stringToMoneyFormat(item),
            },
          ]
        : []),
    ];
  }, [type]);

  /**
   * 테이블 데이터 정제
   * --
   */
  const tableData = React.useMemo(() => {
    if (!data.length) return [];

    const filteredData = data.filter((_item) => _item.type === type);

    const newData = filteredData.reduce((acc, cur) => {
      const {
        product,
        payment_price,
        payment_state,
        received_present,
        shipping_type,
      } = cur;

      const lower = type.toLocaleLowerCase();
      const idx = product[`${lower}_id`];
      const isExist = acc[idx];

      if (isExist) {
        acc[idx] = {
          ...isExist,
          total_sales: acc[idx]['total_sales'] + payment_price,
          [`${payment_state}_sales`]:
            acc[idx][`${payment_state}_sales`] + payment_price,
          [`${payment_state}_count`]:
            acc[idx][`${payment_state}_count`] + received_present,
          ...(type === 'PRODUCT'
            ? {
                [shipping_type]: ++acc[idx][shipping_type],
              }
            : {}),
        };
      } else {
        acc[idx] = {
          [`${lower}_name`]: product[`${lower}_name`],
          total_sales: payment_price,
          COMPLETED_sales: 0,
          CANCELLED_sales: 0,
          COMPLETED_count: 0,
          CANCELLED_count: 0,
          DELIVERY: 0,
          STORE_PICKUP: 0,
          [`${payment_state}_sales`]: payment_price,
          [`${payment_state}_count`]: received_present,
          ...(type === 'PRODUCT'
            ? {
                [shipping_type]: 1,
              }
            : {}),
        };
      }

      return acc;
    }, {});

    const sortedData = Object.values(newData).sort(
      (a, b) => b.total_sales - a.total_sales
    );

    return sortedData;
  }, [type, data]);

  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <Table
      bordered
      size="small"
      scroll={{ x: 760, y: 290 }}
      pagination={false}
      columns={columns}
      dataSource={tableData}
      summary={(pageData) => {
        const summary = pageData.reduce(
          (acc, cur) => {
            Object.entries(cur).forEach(([key, value]) => {
              if (key === `${type.toLocaleLowerCase()}_name`) return;

              acc[key] += value;
            });

            return acc;
          },
          {
            total_sales: 0,
            COMPLETED_sales: 0,
            CANCELLED_sales: 0,
            COMPLETED_count: 0,
            CANCELLED_count: 0,
            ...(type === 'PRODUCT'
              ? {
                  DELIVERY: 0,
                  STORE_PICKUP: 0,
                }
              : {}),
          }
        );

        if (type === 'MENU') {
          delete summary['DELIVERY'];
          delete summary['STORE_PICKUP'];
        }

        return (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}>
                <b>합계</b>
              </Table.Summary.Cell>

              {Object.values(summary).map((item, index) => (
                <Table.Summary.Cell key={`summary-${index}`} index={index + 1}>
                  <b>{stringToMoneyFormat(item)}</b>
                </Table.Summary.Cell>
              ))}
            </Table.Summary.Row>
          </Table.Summary>
        );
      }}
    />
  );
};

export default SummaryTable;
